import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

/** Clean sign-in / join gate for signed-out visitors on member-only pages.
 *  Browse Pros stays public — this is for Requests and Request detail. */
export default function AuthGate({
  title = "Requests are for LIMYA members",
  line = "Sign in to see what neighbors near you need help with, or join free in about a minute.",
  testId = "auth-gate",
}) {
  return (
    <div className="bg-[#F5F7F5] min-h-screen flex flex-col">
      <Header/>
      <div className="flex-1 grid place-items-center px-6 py-20">
        <div className="max-w-md w-full bg-white border border-black/[0.07] rounded-2xl p-8 text-center" data-testid={testId}>
          <span className="w-11 h-11 rounded-full bg-[#E1EDE7] grid place-items-center mx-auto mb-4">
            <Lock size={18} className="text-[#245544]"/>
          </span>
          <h1 className="text-2xl font-bold text-[#2D2926] mb-2" style={{ fontFamily: "Outfit" }}>{title}</h1>
          <p className="text-sm text-[#2D2926]/65 leading-relaxed mb-6">{line}</p>
          <div className="flex flex-col sm:flex-row gap-2.5 justify-center">
            <Link to="/register" className="btn-lime px-5 py-2.5 text-sm font-semibold" data-testid="auth-gate-join">Join LIMYA — free</Link>
            <Link to="/login" className="px-5 py-2.5 text-sm font-semibold rounded-full border border-black/10 text-[#2D2926] hover:bg-black/[0.03] transition" data-testid="auth-gate-signin">Sign in</Link>
          </div>
          <p className="text-xs text-[#2D2926]/45 mt-5">
            Just looking? <Link to="/search" className="underline hover:text-[#245544]" data-testid="auth-gate-browse">Browse local Pros</Link> — no account needed.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
}
